import { Component } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import 'jquery-slimscroll';


import { AdminGuard } from './../../../_guards/admin.guard';
import { ClientGuard } from './../../../_guards/client.guard';
import { StaffGuard } from './../../../_guards/staff.guard';
import { ManagerGuard } from './../../../_guards/manager.guard';

import { User } from '../../../_models/index';



import {DemoService} from '../../../demo.service';

import { Meta, Title } from '@angular/platform-browser';
// import { ThrowStmt } from '@angular/compiler';


import { Brand } from './../../../api/brand';
import { MysqlService } from './../../../services/mysql.service';
import { GlobalFunctionsService } from './../../../services/global-functions.service';


declare var jQuery:any;

@Component({
  selector: 'navigationStaff',
  templateUrl: 'navigationStaff.template.html'
})

export class NavigationStaffComponent {

  brandMysql: any;
  currentUserID: any;
  currentPhoto: any;
  currentAccessLevel: any;
  currentBrandID: any;
  currentUser: User;
  users: User[] = [];
  brand: any;
  brandData: any;



  constructor( public router: Router,
    private _mysqlService: MysqlService, private route: ActivatedRoute,
    public _demoService: DemoService, public gfunc: GlobalFunctionsService
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser') as string);
    this.currentBrandID = this.currentUser.brand_id;
    this.currentAccessLevel = this.currentUser.access_level;
    this.currentPhoto = this.currentUser.access_level;
    this.currentUserID = this.currentUser.user_id;
    this.getBrand(this.currentBrandID);

  }


  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {

    jQuery('#side-menu').metisMenu();

    if (jQuery('body').hasClass('fixed-sidebar')) {
      jQuery('.sidebar-collapse').slimscroll({
        height: '100%'
      });
    }
  }

  activeRoute(routename: string): boolean {
    return this.router.url.indexOf(routename) > -1;
  }



  private getBrandMysql(brand_id) {
    this._mysqlService.getMysqlBrandDatas(brand_id)
      .subscribe(
        res => this.brandMysql = res,
        err => console.error(err.status)
      );
  }

  getBrand(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
    data => { this.brand = data;
    let  res = data;
    this.brandData = res;
    },
     err => console.error(err),
     () => console.log('Brand Loaded.')
   );
  }



}
